import { ss } from '@/utils/storage'
import Cookies from 'js-cookie'

const LOCAL_STORAGE_KEY = 'appSettings'

export type Language = 'ar_SA' | 'en_US' | 'zh_CN' | 'ko_KR' | 'tr_TR'

export type Direction = 'ltr' | 'rtl'

export interface AppState {
    lang: Language
    direction: Direction
}

export function defaultSettings(): AppState {
    return { lang: 'en_US', direction: 'ltr' }
}

export function getLocalSetting(): AppState {
    const lang = Cookies.get('lang') as Language
    const localSetting: AppState = ss.get(LOCAL_STORAGE_KEY) || defaultSettings()
    if (lang) {
        const isSupportLang = ['ar_SA', 'en_US', 'zh_CN', 'ko_KR', 'tr_TR'].includes(lang)
        localSetting.lang = isSupportLang ? lang : 'en_US'
        localSetting.direction = lang === 'ar_SA' ? 'rtl' : 'ltr'
        if (!isSupportLang) {
            Cookies.set('lang', 'en_US')
        }
    }
    return { ...defaultSettings(), ...localSetting }
}

export function setLocalSetting(setting: AppState): void {
    ss.set(LOCAL_STORAGE_KEY, setting)
}